module.exports = __webpack_public_path__ + "static/media/feejoy-logo.9d1826b7.png";